export interface CertificationBadge {
  id: string;
  body: string; // issuing body, e.g. "Marine Stewardship Council"
  scope: string; // which species/suppliers it covers
  validFrom: string; // ISO date
  validTo: string; // ISO date
  explanation: string; // plain-language "what this means"
}

// TODO(content): MSC (Marine Stewardship Council) and ASC (Aquaculture
// Stewardship Council) are real, internationally recognised accreditation
// bodies with real public registries. Claiming ZenFresh holds one of their
// certifications would be a specific, checkable false credibility claim
// about a real external organisation — a stricter case than certifications.ts
// (Compliance page), which only makes self-descriptive claims about
// ZenFresh's own internal practices ("Cold-Chain Certified") with no named
// external accreditor attached. Ships empty until a real certification
// exists. CertificationBadgeGrid.tsx shows an honest "pursuing
// certification" state while this is empty.
export const CERTIFICATION_BADGES: CertificationBadge[] = [];
